import { graphql } from "relay-runtime"
import { useMutationWithErrorToast } from "@/hooks/useMutationWithErrorToast"
import { useSendChatMessageMutation as useSendChatMessageMutationType } from "@/modules/chats/services/__generated__/useSendChatMessageMutation.graphql"

const mutation = graphql`
  mutation useSendChatMessageMutation($input: SendChatMessageInput!, $connections: [ID!]!) {
    sendChatMessage(input: $input) {
      sendChatMessageOutput {
        message @prependNode(connections: $connections, edgeTypeName: "ChatMessageEdge") {
          ...ChatMessageFragment @relay(mask: false)
        }
        greeting {
          ...ChatGreetingFragment @relay(mask: false)
        }
      }
      errors {
        ... on ChatThreadNotFound {
          threadId
          message
        }
        ... on ChatMessageTranslationFailed {
          threadId
          message
        }
      }
    }
  }
`

export const useSendChatMessageMutation = () => {
  return useMutationWithErrorToast<useSendChatMessageMutationType>(mutation)
}
